import { useTranslation } from "react-i18next";
import { useAppSelector } from "src/common/state/hooks";
import Navigation from "../../common/components/Navigation/Navigation";
import { getCurrentProject } from "src/features/projects/state/projectsSlice";
import ProjectThumbnail from "./ProjectThumbnail";

const EditProjectThumbnailWrapper = () => {
  const { t } = useTranslation();

  const selectedProject = useAppSelector(getCurrentProject);

  return (
    <>
      <Navigation
        title={`${t("pages.editProjectName.title")}: ${selectedProject.name}`}
        isProjectView={true}
      />
      <ProjectThumbnail mode="edit-thumbnail" />
    </>
  );
};

export default EditProjectThumbnailWrapper;
